import { Link } from 'react-router-dom';
import { FolderX, ArrowLeft } from 'lucide-react';

export function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-bg gap-4 relative overflow-hidden">
      <div className="pointer-events-none absolute top-1/4 left-1/2 -translate-x-1/2 w-96 h-96 rounded-full bg-primary/15 blur-[120px] animate-float" />
      <div className="relative flex flex-col items-center gap-3 animate-fadeInUp">
        <div className="flex items-center justify-center w-24 h-24 rounded-3xl bg-card border border-border-soft animate-float">
          <FolderX className="w-12 h-12 text-primary/70" />
        </div>
        <p className="text-7xl font-bold gradient-text">404</p>
        <h1 className="text-xl font-semibold text-text">页面不存在</h1>
        <p className="text-text-muted text-sm">你访问的页面可能已被移动或删除</p>
        <Link to="/files" className="group mt-2 inline-flex items-center gap-2 px-5 py-2.5 brand-gradient text-white rounded-xl text-sm font-medium btn-press soft-shadow transition-all hover:brightness-110">
          <ArrowLeft className="w-4 h-4 transition-transform group-hover:-translate-x-1" />
          返回文件页
        </Link>
      </div>
    </div>
  );
}
